import { PageProjectEdit } from "@components/modules/projects/edit/PageProjectEdit";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { NavigationProjects } from "@src/components/widgets/AppSubNav";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Edit project`}
    navigation={<NavigationProjects projectId={id} />}
  >
    <PageProjectEdit />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/edit")({
  component: RouteComponent,
});
